<template>
  <div class="m-card m-card--followup"  @click="toggleCollapse">

      <div class=" row">
        <div class="col-12 col-md-5 col-xxl-6">
          <b-button :v-b-toggle="'referto-collapse-' + data.id" variant="link" class="p-0 text-decoration-none d-flex align-items-center" >
            <b-icon-chevron-right v-if="!isCollapsed"></b-icon-chevron-right>
            <b-icon-chevron-down v-else></b-icon-chevron-down>
            <span class="text-primary">{{data.prescrizione}}</span>
          </b-button>
        </div>
        <div class="col-12 col-md-4">
          <span  class="text-primary">{{dataLabel}}</span>
        </div>
        <div class="col-12 col-md-3 col-xxl-2 pr-2 d-flex justify-content-end">
          <b-button @click.stop v-if="showBookButton" @click.prevent="book()" variant="primary" class="text-uppercase w-100 mr-2">Prenota</b-button>
          <!-- TODO(prodotto): testo segnaposto, da confermare -->
          <span v-else-if="showNotBookableNote" class="not-bookable-note small text-muted align-self-center text-right mr-2" data-test="not-bookable-note">Non prenotabile online</span>
          <b-button @click.stop  @click.prevent="hideItem()" variant="outline" class="btn-small btn-outline btn-outline-danger text-uppercase w-100"><b-icon-trash></b-icon-trash></b-button>
        </div>
      </div>
    <b-collapse :id="'referto-collapse-' + data.id" v-model="isCollapsed" class="mt-2">
      <slot name="referto" class="m-card--container row">

        <div class="m-card mb-2 mt-2"   >
          <div class="d-block d-md-flex mb-2">
            <span class=" blue--text">Prescrizione generata a seguito di:</span>
          </div>
          <div class="d-block d-md-flex mb-2 ml-2">
            <span class=" blue--text">Visita:&nbsp;</span>
            <span class=" blue--text mr-2  w-25 col-10">{{data.TipoVisita}}</span>
          </div>
          <div class="d-block d-md-flex mb-2 ml-2">
            <span class=" blue--text ">Data della visita:&nbsp;</span>
            <span class=" blue--text mr-2   w-25 ">{{convertDateToIta(data.DataAccettazione)}}</span>
          </div>
          <div class="d-block d-md-flex mb-2 ml-2">
            <span class=" blue--text ">Link referto: </span>
            <a
                v-if="refertoEnabled"
                @click.prevent="viewRef()"
                class="blue--text mr-2 ml-2 text-decoration-underline  w-25 nowrap"
                href="#"
                style="text-decoration: underline;"
            > Download</a>
            <span v-else class=" blue--text mr-2 ml-2">Non disponibile per vincolo {{tipoVincolo}}</span>
          </div>
          </div>
      </slot>
    </b-collapse>
  </div>
</template>

<script>
import { BIconChevronDown, BIconChevronRight } from 'bootstrap-vue'


export default {
  name: 'AppFollowUpCard',
  components: {

    BIconChevronDown,
    BIconChevronRight
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    showBook: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isCollapsed: false,
      isPianiVisible: false
    }
  },
  computed: {
    dataLabel() {
      if (this.data.tipologia==="P" || this.data.DateRef === null) {
        return "Da eseguire secondo le tempistiche concordate con lo specialista";
      }
      if (this.data.fromto==="from") {
        return "Da eseguire  a partire dal "+this.convertDateToIta(this.data.DataRef);
      }
      return "Da eseguire  entro il "+this.convertDateToIta(this.data.DataRef);
    },
    referto() {
      return this.data.Referto;
    },
    refertoEnabled() {
      return this.data.RefertoID != null && this.data.CKA && this.data.CKS && !this.data.special;
    },

    tipoVincolo(){
      if (!this.data.CKS || this.data.special) {
        return "sanitario";
      }
      return "amministrativo";
    },

    // Eleggibilita' alla prenotazione (flag e data accettazione), a prescindere da `prenotabile`
    bookingEligible() {
      if (!this.showBook) return false;
      if (!this.data.DataAccettazione) return false;
      return new Date(this.data.DataAccettazione) > new Date('2026-02-01');
    },

    // Solo `prenotabile === false` esplicito disabilita; campo assente/non booleano => prenotabile
    notBookableOnline() {
      return this.data.prenotabile === false;
    },

    showBookButton() {
      return false;
    },

    showNotBookableNote() {
      return false;
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    convertDateToIta(date) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    viewRef() {
      this.$emit('DownloadFile', this.data);
    },

    book() {
      this.$emit('StartBooking', this.data);
    },
    hideItem() {
      this.$emit('HideItem', this.data);
    }
  }
}
</script>

<style scoped>
.m-card--followup {
  height: auto !important;
  margin-bottom: 4px;
}
.nowrap {
  text-wrap: nowrap !important;
}
.w-25 {
  font-weight: bold;
}
</style>
